import React, {useEffect, useState,useRef,useContext} from 'react';
import './App.css';
import Home from './component/Home';
import {
  BrowserRouter,
  Routes, // instead of "Switch"
  Route,
  redirect
} from "react-router-dom";
import Login from './component/Login';
import useToken from './component/useToken';
import { socket, SocketContext } from './component/SocketContext';
import { HelmetProvider } from 'react-helmet-async';


//import socketIO from 'socket.io-client';
/* 
          // @ts-ignore */
//const socket = socketIO.connect('http://localhost:4000');

const App: React.FC = () => {

  
  const { token, setToken } = useToken();


 function AppendToLocalStorageV(name:any, value:any) {
    let n = 0;
    while (localStorage.getItem(name + n)) {
        n++;
    }
    localStorage.setItem(name + n, value); //add item at first available index number
}
  useEffect(() => {
    socket.on('messageResponse', (data:any) => {
     
      AppendToLocalStorageV("workflow",JSON.stringify(data));
      window.dispatchEvent(new Event("storage"));
    });
    socket.on('errorResponse', (data:any) => {
      AppendToLocalStorageV("workflow",JSON.stringify(data));
      window.dispatchEvent(new Event("storage"));
    });

  }, [socket]);


  if(!token) {
    return <Login setToken={setToken} />
  }
  
 
 return (
  <HelmetProvider>
  <div className="App">
  
    <BrowserRouter>
    <SocketContext.Provider value={socket}>
      <Routes>
        
        <Route path="/" element={<Home />} />
        
      </Routes>
      </SocketContext.Provider>
    </BrowserRouter>
  
 </div>
 </HelmetProvider>
 )
}

export default App;

